import { render, staticRenderFns } from "./groupPosition.vue?vue&type=template&id=1b8babf6&"
import script from "./groupPosition.vue?vue&type=script&lang=ts&"
export * from "./groupPosition.vue?vue&type=script&lang=ts&"
import style0 from "./groupPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports